var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_global",
    "data-name": "vuesax/linear/global",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "global"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10Z",
    transform: "translate(174 254)",
    fill: "none",
    stroke: "#09A047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.463,0h1a28.424,28.424,0,0,0,0,18h-1",
    transform: "translate(179.538 255)",
    fill: "none",
    stroke: "#09A047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0A28.424,28.424,0,0,1,0,18",
    transform: "translate(187 255)",
    fill: "none",
    stroke: "#09A047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,1V0A28.424,28.424,0,0,0,18,0V1",
    transform: "translate(175 267)",
    fill: "none",
    stroke: "#09A047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,1.463a28.424,28.424,0,0,1,18,0",
    transform: "translate(175 259.538)",
    fill: "none",
    stroke: "#09A047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(196 276) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalActive);
export default __webpack_public_path__ + "static/media/global-active.2fbedea91e16a49736ef3913cf74ab39.svg";
export { ForwardRef as ReactComponent };